import {loginApi} from 'common/api/entitiesApi'
import {LogoutOutlined, SettingOutlined, UserOutlined} from '@ant-design/icons';
import {Avatar, Button, Dropdown, MenuProps} from 'antd';
import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {AdvertiserBalanceBean} from 'common/api/api';
import {useUserContext} from 'common/context/UserContext';

interface Props {
  balance?: AdvertiserBalanceBean;
}

export const ProfileMenu: React.FC<Props> = ({ balance }) => {
  const navigateTo = useNavigate();

  const { user } = useUserContext();

  const logout = () =>
    loginApi.logout().then((success) => {
      if (success) {
        navigateTo('/login');
      }
    });

  const items: MenuProps['items'] = [
    {
      key: 'profile',
      label: (
        <Link to={`/profile/${user?.id}/edit`}>
          <SettingOutlined /> Edit Profile
        </Link>
      )
    },
    {
      key: 'logout',
      label: (
        <a onClick={logout}>
          <LogoutOutlined /> Logout
        </a>
      )
    }
  ];

  return (
    <div style={{height: 60, display: 'flex', alignItems: 'center'}}>
      <Dropdown menu={{ items }} trigger={['click']}>
        <Button type={'text'}>
          {/* <Avatar style={{ backgroundColor: '#438DD7' }} icon={<UserOutlined />} /> {user?.email}{' '} */}
          <Avatar style={{ background: 'transparent', fontSize: 32 }} icon={<UserOutlined />} />
        </Button>
      </Dropdown>
    </div>
  );
};

export default ProfileMenu;
